import { render, staticRenderFns } from "./rounded_image_on_cards.vue?vue&type=template&id=feb78c7a&scoped=true&"
import script from "./rounded_image_on_cards.vue?vue&type=script&lang=js&"
export * from "./rounded_image_on_cards.vue?vue&type=script&lang=js&"
import style0 from "./rounded_image_on_cards.vue?vue&type=style&index=0&id=feb78c7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb78c7a",
  null
  
)

export default component.exports